import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import appRoutes from "./routes";

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
// semi search 360 design system — imported last so it wins over App.css + Bootstrap
import "./design-system/tokens.css";
import "./design-system/ds-components.css";
import "./design-system/ds-overrides.css";
import LayoutWrapper from "./LayoutComponent";
import { store } from "./store";
import { resetBootstrap } from "./reducers/app.reducer";
import HeaderComponent from "./screens/Header/header.component";
import PublicLayoutWrapper from "./PublicComponent";
import LoginComponent from "./screens/Login/login.component";
import SignupComponent from "./screens/Signup/signup.component";

// Set favicon dynamically
const favicon = document.createElement("link");
favicon.rel = "icon";
favicon.href = "/assets/img/favicon.png";
document.head.appendChild(favicon);

// 🧭 Component to handle title updates
function TitleManager() {
  const location = useLocation();

  useEffect(() => {
  const navType =
    performance.getEntriesByType("navigation")[0]?.type;

  if (navType === "reload") {
    store.dispatch(resetBootstrap());
  }
}, []);
  useEffect(() => {
    const currentRoute = appRoutes.find((route) =>
      location.pathname.match(
        new RegExp(`^${route.path.replace(/:\w+/g, "[^/]+")}$`)
      )
    );
    document.title = currentRoute?.title || "Semisearch Ecommerce";
  }, [location]);

  return null;
}


function App() {
  return (
    <Router>
      <TitleManager />

      <Routes>
        <Route element={<PublicLayoutWrapper />}>
          <Route path="/login" element={<LoginComponent />} />
          <Route path="/register" element={<SignupComponent />} />
        </Route>
        <Route element={<LayoutWrapper />}>
          {appRoutes
            .filter(
              (route) =>
                route.path !== "/login" && route.path !== "/signup"
            )
            .map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={route.element}
              />
            ))}
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
